"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_LLAMADAS_SALIENTES_FALLIDAS_COLUMNS_MAP = void 0;
exports.SORTABLE_LLAMADAS_SALIENTES_FALLIDAS_COLUMNS_MAP = {
    id: 'id',
    fecha: 'calldate',
    prefijo: 'prefijo',
    destino: 'numero',
    ani: 'src',
    duracion_total: 'duration',
    disposition: 'disposition',
    sip_cause: 'SIPcause',
};
